export var CONSTANTS = {
  CATALOG_PRICE_MISSING_MESSAGE: 'Catalog Price has not been configured for this sku',
  NO_PRICE_MESSAGE: 'No Contracts or Catalog Price found for this sku.',
  CATALOG_PRICE: 'Catalog Price',
  MANUFACTURING_COST: 'Manufacturing Cost',
  CONTRACTS: 'Contracts',
  NETWORK: 'Network',
  MCPSKU: 'McpSku',
  MCPSKU_CLASSES: ['order', 'tenant'],
  UNRESOLVABLE: 'unresolvable',
  FULLYRESOLVED: 'fullyResolved',
  ERROR: 'error',
  MAXIMUM_COMBINATIONS_COUNT: 1000000
};
export var ACTION_BULK_EXPORT = {
  TOGGLE_EXPORT_TYPE_MODAL: 'TOGGLE_EXPORT_TYPE_MODAL',
  TOGGLE_CUSTOM_BULK_EXPORT_MODAL: 'TOGGLE_CUSTOM_BULK_EXPORT_MODAL',
  TOGGLE_IS_EXPORTED: 'TOGGLE_IS_EXPORTED',
  CHANGE_EXPORT_TYPE: 'CHANGE_EXPORT_TYPE',
  SUBMIT_EXPORT_TYPE: 'SUBMIT_EXPORT_TYPE',
  TOGGLE_TASKS_MODAL: 'TOGGLE_TASKS_MODAL',
  SET_TASKS_INFO: 'SET_TASKS_INFO',
  HANDLE_SEARCH_JOBS_CHANGE: 'HANDLE_SEARCH_JOBS_CHANGE',
  DELETE_JOB: 'DELETE_JOB',
  DELETE_JOB_SET_STATUS: 'DELETE_JOB_SET_STATUS',
  TOGGLE_CUSTOM_UPLOAD_MODAL: 'TOGGLE_CUSTOM_UPLOAD_MODAL'
};
export var ACTION_CUSTOM_EXPORT = {
  TOGGLE_EXPORT_TYPE_MODAL: 'TOGGLE_EXPORT_TYPE_MODAL',
  TOGGLE_EMAIL_SENT_STATUS: 'TOGGLE_EMAIL_SENT_STATUS',
  INITIALIZE_STATE: 'INITIALIZE_STATE',
  LOAD_POSSIBILITIES_SET_FROM_RULE_SET: 'LOAD_POSSIBILITIES_SET_FROM_RULE_SET',
  ON_CLICK_ATTRIBUTE: 'ON_CLICK_ATTRIBUTE',
  ON_CHECKBOX_TOGGLE: 'ON_CHECKBOX_TOGGLE',
  SHOW_ADD_VALUE_LINK: 'SHOW_ADD_VALUE_LINK',
  ON_BLUR_CUSTOM_INPUT: 'ON_BLUR_CUSTOM_INPUT',
  ON_SUBMIT_CUSTOM_INPUT: 'ON_SUBMIT_CUSTOM_INPUT',
  ON_CUSTOM_INPUT_CHANGE: 'ON_CUSTOM_INPUT_CHANGE'
}; // contracts shipping constants

export var ACTION_CONTRACTS = {
  SET_SHIPPING_DATA: 'SET_SHIPPING_DATA',
  SET_PRODUCT_PRICE_DATA: 'SET_PRODUCT_PRICE_DATA',
  CLEAR_GRID_DATA: 'CLEAR_GRID_DATA'
}; // price explorer headers

export var ACTION_PRICE_EXPLORER_GRID = {
  CREATE_HEADERS: 'CREATE_HEADERS',
  CREATE_COMPETITIVE_HEADERS: 'CREATE_COMPETITIVE_HEADERS',
  REMOVE_ERROR_MESSAGE_FROM_HEADERS: 'REMOVE_ERROR_MESSAGE_FROM_HEADERS',
  ADD_ERROR_MESSAGES_TO_HEADERS: 'ADD_ERROR_MESSAGES_TO_HEADERS',
  SET_ROW_DATA_BY_RESULTS: 'SET_ROW_DATA_BY_RESULTS',
  SET_SELLERS: 'SET_SELLERS',
  SET_MERCHANTS: 'SET_MERCHANTS',
  SET_PRICE_CONFIGURATIONS: 'SET_PRICE_CONFIGURATIONS',
  SET_PRICING_MODE: 'SET_PRICING_MODE',
  SET_ACCOUNT_MAP: 'SET_ACCOUNT_MAP',
  SET_CANCELABLE_PROMISE: 'SET_CANCELABLE_PROMISE',
  SET_PRICE_MODEL_INFO: 'SET_PRICE_MODEL_INFO',
  SET_RULE_SET_INFO: 'SET_RULE_SET_INFO',
  SET_ROW_DATA_BY_PRICE_MODE: 'SET_ROW_DATA_BY_PRICE_MODE',
  SET_GRID_HEADERS: 'SET_GRID_HEADERS',
  SAVE_RULE_SET_INFO: 'SAVE_RULE_SET_INFO',
  ADD_SHIPPING_DATA_TO_ROW_DATA: 'ADD_SHIPPING_DATA_TO_ROW_DATA',
  SAVE_LOGGED_SKU: 'SAVE_LOGGED_SKU',
  SAVE_USER_PERMISSION_FULFILLER: 'SAVE_USER_PERMISSION_FULFILLER',
  SET_IS_LOADING_EQUIVALENCIES: 'SET_IS_LOADING_EQUIVALENCIES',
  GET_IS_LOADING_EQUIVALENCIES: 'GET_IS_LOADING_EQUIVALENCIES'
}; // pricing grid constants

export var ACTION_PRICING_GRID_CONST = {
  LOAD_PRICING_GRID_DATA: 'LOAD_PRICING_GRID_DATA',
  SET_DELIVERY_LOCATIONS: 'SET_DELIVERY_LOCATIONS',
  ON_PRICE_MODE_CHANGE: 'ON_PRICE_MODE_CHANGE'
};
export var ACTION_PRICING_GRID_COMPONENT = {
  LOAD_PRICING_GRID_DATA: 'LOAD_PRICING_GRID_DATA',
  CLEAR_STATE: 'CLEAR_STATE',
  SAVE_DELIVERY_LOCATIONS: 'SAVE_DELIVERY_LOCATIONS',
  ON_PRICE_MODE_CHANGE: 'ON_PRICE_MODE_CHANGE',
  SAVE_PRODUCTION_TIME: 'SAVE_PRODUCTION_TIME',
  SAVE_SHIPPING_CONFIGURATION: 'SAVE_SHIPPING_CONFIGURATION',
  TOGGLE_SAVE_SHIPPING_CONFIG: 'TOGGLE_SAVE_SHIPPING_CONFIG',
  ON_SHIPPING_SUBMIT: 'ON_SHIPPING_SUBMIT',
  SAVE_BUDGET_RATES: 'SAVE_BUDGET_RATES',
  SAVE_LOGGER: 'SAVE_LOGGER',
  SAVE_FULFILLMENT_LOCATIONS: 'SAVE_FULFILLMENT_LOCATIONS',
  SET_SELECTED_TAB: 'SET_SELECTED_TAB'
};
export var ACTION_PRICING_GRID_LAYOUT = {
  SET_SUPPORTED_CURRENCIES: 'SET_SUPPORTED_CURRENCIES'
};